module.exports = __webpack_public_path__ + "img/google-play.e1e0ef01.svg";